export default class MapVisibilityEnum {
    static get HIDDEN() {
        return 'hidden';
    }

    static get VISIBLE() {
        return 'visible';
    }

    static get options() {
        return {
            HIDDEN: this.HIDDEN,
            VISIBLE: this.VISIBLE
        };
    }
}
